<div class="course-assign-license-error-dialog">
  <div mat-dialog-title>
    <h1 id="course-assign-license-error-dialog">{{ 'Save Failed' | translate }}</h1>
    <cl-btn
      mat-dialog-close
      icon="close"
      [label]="'close dialog' | translate"
      buttonStyle="alert small"
      class="course-assign-license-error-dialog__close" />
  </div>
  <div mat-dialog-content>
    <div class="course-assign-license-error-dialog__info">
      <p>
        {{ 'No available licenses to assign course.' | translate }}
      </p>
      @if (isTeacher$ | async) {
        <p>
          {{
            'We recommend you discuss with your school administrator to review license availability and ensure your' +
              ' licensing needs are met to support your students.' | translate
          }}
        </p>
      }
      @if (isSchoolOrDistrictAdmin$ | async) {
        <p>
          {{ 'To view license availability, go to ' | translate }}
          <span>
            <a
              [routerLink]="redirectLink"
              mat-dialog-close>
              {{ '"License Allocations" in the "Organizations" tab' | translate }}
            </a>
          </span>
          {{
            '. Further information regarding license distribution can be found there.' | translate
          }}
        </p>
      }
      @if (isSchoolAdmin$ | async) {
        <p>
          {{
            'If your licensing needs are not met we recommend you discuss with your District Administrator.'
              | translate
          }}
        </p>
      }
      @if (isDistrictAdmin$ | async) {
        <p>
          {{
            'Please reach out to your School Relations contact if additional licenses are needed to support' +
              ' your district licensing needs.' | translate
          }}
        </p>
      }
    </div>
  </div>
  <div mat-dialog-actions>
    <cl-btn mat-dialog-close>{{ 'OK' | translate }}</cl-btn>
  </div>
</div>
